import type { IGhCalloutCard } from '../gpthelp-host-contract';
import { clampText, fitText } from './card-text';
import type { ICardFormat } from './card-text';

/** «Reporte listo: {filename}» with «Descargar» (the file is in this browser). */
export function exportReadyCard(
  input: { id: string; exportId: string; filename: string },
  fmt: ICardFormat
): IGhCalloutCard {
  return {
    id: input.id,
    v: 1,
    type: 'callout',
    tone: 'success',
    title: fitText(
      fmt,
      'assistant.export.ready',
      { filename: input.filename },
      'filename',
      160
    ),
    actions: [
      {
        id: 'download',
        kind: 'host',
        label: clampText(fmt.t('assistant.export.download'), 40),
        icon: 'download',
        style: 'outline',
        payload: { exportId: input.exportId },
        // The file waits in this browser: no connection needed.
        requiresOnline: false,
      },
    ],
  };
}

/** «Este archivo ya no está disponible. Pídalo de nuevo.» */
export function exportGoneCard(id: string, fmt: ICardFormat): IGhCalloutCard {
  return {
    id,
    v: 1,
    type: 'callout',
    tone: 'warning',
    title: clampText(fmt.t('assistant.export.gone'), 160),
  };
}
